/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { FC } from 'react';
import clsx from 'clsx';
import { CircleClose24, FilePdf64, FileWord64, Right24 } from '@bphxd/ds-core-react/lib/icons';
import classes from '../../organisms/CertificateAttachments/CertificateAttachments.module.scss';
import { Button, Spinner } from '@bphxd/ds-core-react';
import { MediaMetadataMimeEnum } from '../../../graph-queries/__generated__/graphql';
import { MEDIA_ALLOWED_MIME_TYPES } from '../../../lib/constants/dbConstants';

type Attachment = {
  id: number;
  url: string;
  fileName: string;
  mime: string;
};

const AttachmentsList: FC<{
  attachments: Attachment[];
  loading?: boolean;
  toBeDeleted?: number[];
  onToggleDelete?: (id: number) => void;
  showAll?: boolean;
  onShowAll?: () => void;
}> = ({ attachments, loading, toBeDeleted, onToggleDelete, showAll, onShowAll }) => {
  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center flex-grow-1">
        <Spinner />
        <span className="visually-hidden">Loading...</span>
      </div>
    );
  }

  return (
    <div className={classes.attachments}>
      {attachments.map((att) => (
        <div className={classes.attachment} key={att.id}>
          <div className={classes.imgContainer}>
            <a href={att.url} download title={`Click to download ${att.fileName}`}>
              {att.mime === MEDIA_ALLOWED_MIME_TYPES[MediaMetadataMimeEnum.Pdf] ? (
                <div className={classes.icon}>
                  <FilePdf64 title={att.fileName} />
                  {att.fileName}
                </div>
              ) : att.mime === MEDIA_ALLOWED_MIME_TYPES[MediaMetadataMimeEnum.Doc] ||
                att.mime === MEDIA_ALLOWED_MIME_TYPES[MediaMetadataMimeEnum.Docx] ? (
                <div className={classes.icon}>
                  <FileWord64 title={att.fileName} />
                  {att.fileName}
                </div>
              ) : (
                <img src={att.url} alt={att.fileName} />
              )}
            </a>
            {onToggleDelete && <div
              className={clsx({
                [classes.closeIcon]: true,
                [classes.remove]: toBeDeleted?.includes(att.id),
              })}
              onClick={() => onToggleDelete(att.id)}
            >
              <CircleClose24 title="Click to remove" />
            </div>}
          </div>
        </div>
      ))}
      {!showAll && onShowAll && (
        <div className={classes.all}>
          <Button level="quartenary" Icon={Right24} iconPosition="end" onClick={onShowAll}>
            View All
          </Button>
        </div>
      )}
    </div>
  );
};

export default AttachmentsList;
